module.exports = __webpack_public_path__ + "assets/img/teammanager.f9bc8d27.svg";